import {
  InstallationType,
  RequestStatus,
  RequestType,
  RequesterTeam,
  SipTrunkReason,
} from './types';

export const REQUEST_TYPE_LABEL: Record<RequestType, string> = {
  SIP_TRUNK: 'SIP Trunk',
  QUEUE_EQUIPMENT: 'Digital Queue Equipment',
  PHONE_HARDWARE: 'Phone Hardware',
};

export const STATUS_LABEL: Record<RequestStatus, string> = {
  PENDING: 'Pending',
  IN_PROGRESS: 'In progress',
  IN_TRANSIT: 'In transit',
  BACKORDER: 'Backorder',
  COMPLETED: 'Completed',
  REJECTED: 'Rejected',
};

export const STATUS_CLASSES: Record<RequestStatus, string> = {
  PENDING: 'bg-yellow-100 text-yellow-800',
  IN_PROGRESS: 'bg-blue-100 text-blue-800',
  IN_TRANSIT: 'bg-indigo-100 text-indigo-800',
  BACKORDER: 'bg-orange-100 text-orange-800',
  COMPLETED: 'bg-green-100 text-green-800',
  REJECTED: 'bg-red-100 text-red-800',
};

// Fallback pill for a status this bundle predates.
export const UNKNOWN_STATUS_CLASSES = 'bg-gray-100 text-gray-800';

// Reaching either of these takes the request out of the working queue and, on
// the backend, requires a resolution note.
export const CLOSED_STATUSES: RequestStatus[] = ['COMPLETED', 'REJECTED'];

export const REQUESTER_TEAM_LABEL: Record<RequesterTeam, string> = {
  SALES: 'Sales',
  CUSTOMER_SUCCESS: 'Customer Success',
  OTHER: 'Other',
};

export const SIP_TRUNK_REASON_LABEL: Record<SipTrunkReason, string> = {
  CLIENT_HAS_NO_TRUNK: 'Client has no SIP trunk',
  CLIENT_TRUNK_INCOMPATIBLE: 'Client trunk is incompatible with our softphone',
  CLIENT_PROVIDER_TOO_SLOW: 'Client provider cannot deliver in time',
  MIGRATION_IN_PROGRESS: 'Client is migrating providers',
  OTHER: 'Other',
};

export const INSTALLATION_TYPE_LABEL: Record<InstallationType, string> = {
  SHIPPING: 'Ship to client',
  ONSITE: 'On-site installation by BrainHi',
  CLIENT_PROVIDED: 'Client provides the hardware',
};

// Installation types where the manager needs somewhere to send a person or box.
export const INSTALLATION_TYPES_NEEDING_ADDRESS: InstallationType[] = ['SHIPPING', 'ONSITE'];

// Matches the backend serializer's CharField(max_length=2000) on notes.
export const COMMENT_MAX_LENGTH = 2000;

export const REQUESTS_QUERY_KEY = 'provisioningRequests';
export const REQUEST_QUERY_KEY = 'provisioningRequest';
export const ASSIGNABLE_USERS_QUERY_KEY = 'provisioningAssignableUsers';

const toOptions = <T extends string>(labels: Record<T, string>): { value: T; label: string }[] =>
  (Object.keys(labels) as T[]).map((value) => ({ value, label: labels[value] }));

export const REQUEST_TYPE_OPTIONS = toOptions(REQUEST_TYPE_LABEL);
export const STATUS_OPTIONS = toOptions(STATUS_LABEL);
export const REQUESTER_TEAM_OPTIONS = toOptions(REQUESTER_TEAM_LABEL);
export const SIP_TRUNK_REASON_OPTIONS = toOptions(SIP_TRUNK_REASON_LABEL);
export const INSTALLATION_TYPE_OPTIONS = toOptions(INSTALLATION_TYPE_LABEL);
